import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "app-page-body",
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: "./page-body.component.html",
    styleUrl: "./page-body.component.scss",
})
export class PageBodyComponent {}
